var map = {
	"./05051f8a-8ac1-4a5f-ab38-6c2fa2d650cc.jpg": 4647,
	"./a2ae0be0-229c-4950-8ee6-35034692a998.jpg": 2304,
	"./icone_alterado.png": 3968,
	"./logoReportAdvocacia.jpeg": 7007,
	"./logoReportAdvocacia.jpg": 18,
	"./logo_default.jpg": 4906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7306;